import {Target, TrendingUp, Users} from 'lucide-react'
import {useLanguage} from '@/contexts/LanguageContext'

const icons = [Target, TrendingUp, Users]

function FeaturesSection() {
  const {t} = useLanguage()

  return (
    <section className="relative z-10 px-6 py-20">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-14 text-white">{t.features.title}</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {t.features.items.map((feature, index) => {
            const Icon = icons[index]
            return (
              <div
                key={feature.title}
                className="rounded-xl border border-white/10 bg-slate-900/60 p-6 transition-all duration-300 hover:border-indigo-400/50 hover:bg-indigo-500/5 hover:-translate-y-1 hover:shadow-[0_0_35px_rgba(99,102,241,0.4)] group"
              >
                <div className="mb-4 flex items-center justify-center w-11 h-11 text-indigo-300 group-hover:text-sky-300 transition-colors">
                  <Icon className="w-7 h-7" />
                </div>
                <h3 className="text-lg font-semibold mb-2 text-white">{feature.title}</h3>
                <p className="text-gray-400 leading-relaxed text-sm">{feature.description}</p>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default FeaturesSection
